import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const Recap = ({ username, password }: { username: string; password: string }): ReactElement => {
 return (
  <Stack p={2} spacing={2}>
   <Stack spacing={1}>
    <Typography variant="subtitle2" fontWeight="bold">
     <FormattedMessage id="docker.website.checkForData" />
    </Typography>
    <Stack direction="row" spacing={1}>
     <Typography variant="subtitle2" fontWeight="bold" minWidth={100}>
      <FormattedMessage id="docker.website.ftpUsername" />:
     </Typography>
     <Typography variant="subtitle2">{username}</Typography>
    </Stack>
    <Stack direction="row" spacing={1}>
     <Typography variant="subtitle2" fontWeight="bold" minWidth={100}>
      <FormattedMessage id="docker.website.ftpPassword" />:
     </Typography>
     <Typography variant="subtitle2">{password}</Typography>
    </Stack>
   </Stack>
  </Stack>
 );
};

export default Recap;
